import { defineComponent as _defineComponent } from 'vue'
import { mdiHuman } from '@mdi/js';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderCustom',
  props: {
    title: null
  },
  setup(__props: any) {



const { VUE_APP_URL_ACESSIBILIDADE } = process.env;

return { __sfc: true,VUE_APP_URL_ACESSIBILIDADE, mdiHuman }
}

})